import React from "react";
import { A } from "../base/plumbing/glrouter";


function PortalFooter() {
	return <footer className="footer w-100">
		<div className="col-md-12">
			<p className="text-muted">
				<span>
					&copy; Good-Loop Ltd, all rights reserved.
					<A href="https://good-loop.com">Good-Loop&trade;</A> is a registered UK company, number SC548356.
				</span>
				<A href="/#about">About this app</A>
			</p>
		</div>
	</footer>;
}


export default PortalFooter;
